// @flow
// idxgen-disable
import { injectReducer } from 'store/configureStore';

import reducer from './reducer';
import * as actions from './actions';
import * as constants from './constants';
import * as selectors from './selectors';
import * as sagas from './sagas';

// Inject reducer to store
injectReducer(constants.COMPONENT_NAME, reducer);

export * from './helpers';

export { reducer, actions, constants, selectors, sagas };



// WEBPACK FOOTER //
// ./src/common/components/dialog/index.js